const matchPath = (path: string): boolean => {
    const hrefs: string[] = window.location.href.split('/')
    return hrefs[hrefs.length - 1] === path.replace('/', '')
}

export default matchPath